import { getServiceOptionStatusFilter, serviceOrdersSlice } from '../../../../reducers/serviceOrdersSlice';
import { StatusFilter } from '../../../../sharedComponents/filter/StatusFilter';
import { ServiceOptionStatus } from '../../serviceOption.types';

export const ServiceOptionStatusFilter = () => {
    const additionalOptionClasses = new Map([[ServiceOptionStatus.CANCELLED, 'bg-white']]);

    return (
        <StatusFilter
            getFilterSelector={getServiceOptionStatusFilter}
            setFilterAction={serviceOrdersSlice.actions.setServiceOptionStatusFilter}
            statusOptions={Object.values(ServiceOptionStatus)}
            optionClassName={additionalOptionClasses}
        />
    );
};
